export const ALL_CHANNELS_ID = 'allChannels';
export const CHANNEL_COUNT_FOR_WALLPAPER = 13;
export const MAIN_CHANNEL_INDEX_IN_WALLPAPER = 6;
